'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' });

var Phonelink = function Phonelink(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Phonelink = (0, _pure2.default)(Phonelink);
Phonelink.muiName = 'SvgIcon';

exports.default = Phonelink;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Phonelink.js
// module id = 2703
// module chunks = 0